<template>
	<div class="home-header">
    <div class="header-address">
      <img src="../../../assets/image/home/address@2x.png" class="header-icon">
      <div>{{ address}}</div>
    </div>
    <div class="shop-address" @click="showShop">
      <div>{{ shop?shop.sname:shoplist[0].sname}}</div>
       <img src="../../../assets/image/home/down.png" class="header-icon">
    </div>
    <div class="scan-address" @click="scanOver">
      <img src="../../../assets/image/home/scan@2x.png" class="scan-icon">
    </div>
    <input style="width:4vw;" type="search" readonly="true"  autocomplete="off" @click="onSearch">
    <div class="header-item" @click="rightClick">
      <img src="../../../assets/image/home/notice@2x.png" class="header-icon">
      <span v-if="isHasUnreadCount"></span>
      <span v-if="isHasUnreadCount">{{systemUnreadCount}}</span>
    </div>
    <div id="yourElement" style="display:none;"></div>
    <mt-actionsheet
      :actions="actionSheet"
      v-model="sheetVisible">
    </mt-actionsheet>
	</div>
</template>

<script>
import { Header, Indicator, Toast, MessageBox } from 'mint-ui';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { ENUM } from '../../../const/enum';
import wx from 'weixin-js-sdk';
import * as ScanCart from '@/api/scan-cart.js'
//import { isNull } from '@/util/validator.js'

const MAX_SHOP_SHOW = 6   // 弹出的门店列表显示的最多的数量

export default {
  name: "myHomeHeader",
  computed: {
    ...mapState({
      config: state => state.config.config,
      isOnline: state => state.auth.isOnline,
      user:state => state.auth.user,
      lastOrderMsgTime: state => state.message.lastOrderMsgTime,
      lastSystemMsgTime: state => state.message.lastSystemMsgTime,
      orderUnreadCount: state => state.message.orderUnreadCount,
      systemUnreadCount: state => state.message.systemUnreadCount,
      shoplist:state => state.auth.shoplist,
      shop:state => state.auth.shop,
      stateAddress:state => state.auth.address,
    }),
    ...mapGetters({
      isHasUnreadCount: 'isHasUnreadCount',
    }),
    address(){
      //let stateAddress = this.$store.state.auth.address ||{}
console.log("location:", this.stateAddress)
      let stateAddress = this.stateAddress || {};
      let addr = '定位中...';
      // if (!this.validator.isNull(stateAddress.poiRegions[0])&&stateAddress.poiRegions[0].name) {
      if ( stateAddress && stateAddress.poiRegions && stateAddress.poiRegions[0] && stateAddress.poiRegions[0].name ) {
        addr = stateAddress.poiRegions[0].name;
      }else if( stateAddress && stateAddress.sematic_description){
        addr = stateAddress.sematic_description
      }else if( stateAddress && stateAddress.formatted_address ){
        addr = stateAddress.formatted_address
      }else if( stateAddress && stateAddress.addressComponent ){
        addr = stateAddress.addressComponent.street || '' 
              + stateAddress.addressComponent.street_number || ''
              + stateAddress.addressComponent.district || ''
              + stateAddress.addressComponent.province || ''
      }else{
        addr = '定位中...'
      }
      return (addr.length>10)?(addr.substr(0,8)+'...'):addr;
      // return '定位中...';
    },
    actionSheet(){
      console.log("shoplist大小：", this.shoplist.length)
/*  
原有的代码，由于下面slice之后感觉不稳定，因此观察一段时间后，如果没有问题则删除这部分注释掉的代码
      let list = this.shoplist;

      for(let l of list){
        let distext = l.distext == '0米'?'定位失败':l.distext
        l.name = l.sname + "("+distext+")"
        if (l.sname == "汉食生鲜西三旗店") {
          l.name = "更多"
          l.method = (item)=>{
            this.$router.push({ name: 'ShopList'});
          }          
        } else {
          l.method = (item)=>{
            this.saveShop(item)
            window.location.reload()
          }          
        }
      }
*/
      let list = this.shoplist.length>MAX_SHOP_SHOW?this.shoplist.slice(0,MAX_SHOP_SHOW+1):this.shoplist  
      let lenList = list.length
      for (let index = 0; index < lenList; index++) {
        const element = list[index];
        if (index == MAX_SHOP_SHOW) {
          element.name = "更多"
          element.method = (item)=>{
            this.$router.push({name:'ShopList'});
          }
        } else {
          let distext = element.distext == '0米'?'定位失败':element.distext
          element.name = element.sname + "（"+distext+"）";
          element.method = (item)=>{
            this.saveShop(item)
            // 清空分类及当前焦点分类，避免带到新的门店中
            this.clearCategoryItems()
            window.location.reload()
          }          
        }

      } 

      return list
    }
  },
  data () {
    return {
      clipboardText:'http://hlmall.bestegou.com/hl2208.html',
      sheetVisible:false
    }
  },
  created() {
    window.sendScanOver=(result)=>{
      this.bybarcode({barcode:result}).then(response => {
          if(response && response.id){
             this.$router.push({'name': 'product', 'query': {'id': response.id }});
          }
        },
        error => {
          MessageBox.alert(error.errorMsg, "商品暂未找到！");
        }
      )
    }
    // 调用原生app 定位方法
		if(window.android){ 
        window.android.acquireJpushRegistrationID();
        window.android.acquireAppVersion();
		}else if(isIphone() && window.webkit){
        window.webkit.messageHandlers.acquireJpushRegistrationID.postMessage(null);
        window.webkit.messageHandlers.acquireAppVersion.postMessage(null);
		}else{
			  window.version = '1.0.5'
		}
		window.sendAppVersion = (version)=>{
			window.version = version
		}
		window.sendJpushRegistrationID= (registrationID)=>{
			window.device_id = registrationID
    }
  },
  methods: {
    ...mapActions({
      bybarcode:'bybarcode',
      fetchConfig: 'fetchConfig',
      fetchScreenCartList: 'fetchScreenCartList',
    }),
    ...mapMutations({
      saveShop:'saveShop',
      clearCategoryItems:'clearCategoryItems'
    }),
    showShop(){
      this.sheetVisible = true
    },
    scanOver() {
      if (!this.isOnline) {
        this.$router.push({ name: 'signin' });
        return false;
      }
      if(this.wxApi.isweixin()){
          let wechat = this.config['wechat.web'];
          let openid = this.$cookie.get('o');
          let that = this;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: wechat.app_id, // 必填，公众号的唯一标识
            timestamp: wechat.timestamp, // 必填，生成签名的时间戳
            nonceStr: wechat.nonceStr, // 必填，生成签名的随机串
            signature: wechat.signature,// 必填，签名，见附录1
            jsApiList: ["qrCode","barCode","scanQRCode"] 
          });
          wx.error(function(res){
              // config信息验证失败会执行error函数，如签名过期导致验证失败，
              //具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              console.error(res)
          });
          wx.ready(()=>{
              wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode","barCode","scanQRCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: (res) => {
                  let barcode = res.resultStr.split(',')[1]
                  let operator_uid = this.user.id
                  ScanCart.barcode(barcode,operator_uid).then(res=>{
                    if(res.error_code ==0){
                      let product = res.goods_groups[0].goods[0].product
                      let pos_subtotal = res.goods_groups[0].goods[0].pos_subtotal
                      let name = "商品名称: "+ product.name
                      let subtotal = "小计: "+ pos_subtotal +" 元"
                      Toast(name)
                    }else(
                      Toast('请求异常:'+res.errorMsg)
                    )
                    console.dir(this.user)
                    this.fetchScreenCartList({operator_uid:this.user.id})
                  }).catch(err=>{
                    Toast(err.errorMsg);
                  })
                }
              });
          });
      }else if(window.android){
        window.android.scanOver();
      }else if(typeof window.webkit == 'object'){
        windowt.webkit.messageHandlers.scanOver.postMessage('');
      }else{
        Toast('该浏览器暂不支持扫一扫!');
      }
    },
    // 获取未读消息数字
    getMessageCount(type) {
      if (this.user != null) {
        let after = null
        if (type === ENUM.MESSAGE_TYPE.SYSTEM) {
          after = this.lastSystemMsgTime ? this.lastSystemMsgTime : Date.parse( new Date()) / 1000
        }
        messageCount(after, type).then(res => {
          if (res) {
            if (type === ENUM.MESSAGE_TYPE.SYSTEM) {
              this.saveSystemUnread(res.count);
            }
          }
        });
      }
    },
    onSearch() {
      this.$router.push({ name: "search", params: { isFromHome: true } });
    },
    rightClick() {
      if (this.isOnline) {
        this.$router.push({ name: 'systemMessageList' });
      } else {
        this.$router.push({ name: "signin" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.home-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: #eb8419;
  z-index:999;
  .header-address {
    font-size:12px;
    padding-left: 10px;
    display: flex;
    flex-direction: row;
    color: #f5f5f5;
    div{
      padding-left: 10px;
      width: 16vw;
      line-height: 12px;
      text-overflow:ellipsis;
    }
  }
  .shop-address{
    justify-content: space-around;
    font-size:12px;
    max-width: 180vw;
    width: 100%;
    border: 1px solid #f5f5f5;
    border-radius: 8px;
    margin: 0 6px;
    color: #f5f5f5;
    text-align: center;
    text-overflow:ellipsis;
    display: flex;
    padding: 4px;
    flex-direction: row;
  }
  .header-item {
    padding-right: 10px;
    padding-left: 10px;
    width: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    span {
			width: 7px;
			height: 7px;
			background-color: red;
			border-radius: 50%;
			position: absolute;
			top: 12px;
      right: 24px;
			font-size: 18px;
		}
  }
  input {
    margin-left: 10px;
    flex: 1;
    flex-basis: 200px;
    border-radius: 16px;
    border: 0px;
    background: url("../../../assets/image/change-icon/search@2x.png") no-repeat 8px center;
    background-size: 16px;
    background-color: #e9ecf0;
    padding: 9px;
    padding-left: 30px;
    color: #a4aab3;
    font-family: "PingFangSC";
    font-size: 14px;
    height: 32px;
    border: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
    &:focus {
      outline-offset: 0px;
      outline: none;
    }
  }
  .header-icon {
    width: 20px;
    height: 20px;
  }
  .scan-address {
    font-size:12px;
    text-align: center;
    width: 10vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .scan-icon {
    width: 20px;
    height: 20px;
  }
  span {
    width: 7px;
    height: 7px;
    position: absolute;
    right: 15px;
    top: 25%;
    background-color: $primaryColor;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/child/HomeHeader.vue